exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".system-status-body{background-color:#0f121a !important}.system-status-body>iframe{border:0px}\n", ""]);

// exports
